module.exports = __webpack_public_path__ + "static/images/1_sunny_bike_day.10fde179.jpg";